import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/pages/SuperAdminLogin.css';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { superadminApi } from '../api/api1';

export default function SuperAdminLogin({ onLogin }) {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const [success, setSuccess] = useState('');

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.height = '100%';
    return () => {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.height = '';
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);
    try {
      const response = await superadminApi.post('/api/superadmin/login', {
        identifier: formData.email.trim(),
        password: formData.password
      });
      const data = response.data || {};

      const user = data.user || data;
      // Token is now stored in HttpOnly cookie by the backend
      localStorage.setItem('superadmin_user', JSON.stringify(user));
      localStorage.setItem('super_admin_logged', '1');
      localStorage.setItem('lastActivity', Date.now().toString());
      setSuccess('Login successful! Redirecting...');
      setTimeout(() => { onLogin?.(); navigate('/superadmin'); }, 800);
    } catch (err) {
      setError(err.response?.data?.error || err.response?.data?.message || 'An error occurred');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sa-login-wrapper">
      <div className="sa-float-circle c1" />
      <div className="sa-float-circle c2" />

      <div className="sa-card">
        <div className="sa-card-header">
          <div className="sa-card-header-overlay" />
<div className="sa-title-row" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <div className="sa-icon">Z</div>
        <h1 className="sa-title">SuperAdmin Portal</h1>
      </div>
      <button
        className="sa-back-btn"
        onClick={() => navigate('-1')}
        style={{
          background: 'transparent',
          border: 'none',
          color: '#4f46e5',
          fontSize: '0.875rem',
          fontWeight: 500,
          cursor: 'pointer'
        }}
      >
        ← Back
      </button>
    </div>
          <p className="sa-subtitle">Sign in to your admin account</p>
        </div>

        <div className="sa-card-body">
          {error && <div className="sa-alert sa-alert-error"><span>⚠️</span><span>{error}</span></div>}
          {success && <div className="sa-alert sa-alert-success"><span>✅</span><span>{success}</span></div>}

          <form onSubmit={handleSubmit}>
            <div className="sa-field">
              <label className="sa-label">Email or Username <span>*</span></label>
              <input type="text" maxLength={32} required
                placeholder="Email or username"
                value={formData.email} onChange={e => setFormData({ ...formData, email: e.target.value.slice(0, 32) })} className="sa-input" />
            </div>

            <div className="sa-field">
              <label className="sa-label">Password <span>*</span></label>
              <div className="sa-password-wrap">
                <input type={showPassword ? 'text' : 'password'} maxLength={32} required placeholder="••••••••"
                  value={formData.password} className="sa-input password-input-no-reveal"
                  onChange={e => setFormData({ ...formData, password: e.target.value.slice(0, 32) })} />
                <button type="button" onClick={() => setShowPassword(!showPassword)} className="sa-eye-btn">
                  {showPassword ? <FaEye/> : <FaEyeSlash/>}
                </button>
              </div>
            </div>

            <button type="submit" disabled={loading} className={`sa-submit-btn ${loading ? 'loading' : 'active'}`}>
              {loading ? <><div className="sa-spinner" /><span>Processing...</span></> : <span>Sign In</span>}
            </button>
          </form>
        </div>

        <div className="sa-card-footer">🔒 Secure Admin Access · Library Management System</div>
      </div>
    </div>
  );
}
